import React from 'react';
import AskAIPage from '../../components/MobileNavigation/AskAIPage';
import useIsMobile from '../../hooks/useIsMobile';

/** PrecisionAI chat page embedded inside DashboardShell. */
export default function DashboardAIPage() {
  const isMobile = useIsMobile();

  if (isMobile) {
    return <AskAIPage menuCurrentPage="askAI" />;
  }

  // Desktop uses the persistent AIChatPanel mounted by DashboardShell. It moves
  // into full-page mode on this route so the active floating chat is preserved.
  return <div style={{ height: '100%' }} />;
}
